'use client';
'use strict';

var client = require('@apollo/client');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var FORMIE_FORM_FRAGMENT = require('../gql/fragments/FORMIE_FORM_FRAGMENT.js');
var FORMIE_FORM_QUERY = require('../gql/queries/FORMIE_FORM_QUERY.js');

/**
 * Custom hook for executing a lazy query using FormieFormQuery and FormieFormQueryVariables.
 *
 * @returns A tuple containing the `getForm` function and `FormDataProps` object.
 */ function useLazyFormieQuery() {
    const [getForm, { data, loading, error }] = client.useLazyQuery(FORMIE_FORM_QUERY.FORMIE_FORM_QUERY);
    const form = generatedCraftcms.getFragmentData(FORMIE_FORM_FRAGMENT.FORMIE_FORM_FRAGMENT, data == null ? void 0 : data.formieForm);
    return [
        getForm,
        {
            form,
            loading,
            error
        }
    ];
}

module.exports = useLazyFormieQuery;
